import { useState } from "react";
import classes from "./Sources.module.css";

export default function Sources({ sources }) {
  const [activeTooltip, setActiveTooltip] = useState(null);
   const filteredSources =
    sources?.filter((source) => !source?.domain_url.includes("vertexaisearch")) || [];
  const handleSourceClick = (sourceFullUrls, index) => {
    // toggle if clicking the same item
    if (activeTooltip?.index === index) {
      setActiveTooltip(null);
    } else {
      setActiveTooltip({ index, sourceFullUrls });
    }
  };

  const handleCloseTooltip = (e) => {
    e.stopPropagation(); 
    setActiveTooltip(null);
  };

  return (
    <ul className={classes.source_list}>
      {filteredSources.map((source, index) => (
        <li
          key={index}
          className={classes.source_item}
          onClick={() => handleSourceClick(source?.fullUrl, index)}
        >
          {source?.domain_url}

          {activeTooltip?.index === index && (
            <div className={classes.tooltip}>
              <button
                className={classes.close_button}
                onClick={handleCloseTooltip}
              >
                ×
              </button>
              {activeTooltip.sourceFullUrls.map((url, i) => (
                <a
                  key={i}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tooltip_link}
                >
                  {url}
                </a>
              ))}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
